import React from 'react';
import classNames from 'classnames';
import { Pages } from 'modules/navigation/domain/enums/pages';
import UDNavLink from 'modules/ud-ui/components/link/nav-link';
import UDColorableIcon from 'modules/ud-ui/components/icon/colorable-icon';
import UDText from 'modules/ud-ui/components/text';
import * as S from './styles';

type Props = { className?: string };

const UDMenuSystemNavigation = (props: Props) => {
  return (
    <S.MenuSystemNavigation
      className={classNames('d-flex flex-column', props.className)}>
      <UDNavLink
        to={Pages.SETTINGS}
        className="d-flex align-items-center pl-10 pr-6 py-2">
        <UDColorableIcon name="gear" componentProps={{ className: 'mr-2' }} />
        Настройки
      </UDNavLink>
      {/*<UDNavLink*/}
      {/*  to={Pages.NOTIFICATIONS}*/}
      {/*  className="notification d-flex align-items-center pl-10 pr-6 py-2">*/}
      {/*  <UDColorableIcon*/}
      {/*    name="notification"*/}
      {/*    componentProps={{ className: 'mr-2' }}*/}
      {/*  />*/}
      {/*  Уведомления*/}
      {/*  <UDText type="footnote" className="count ml-2">*/}
      {/*    7*/}
      {/*  </UDText>*/}
      {/*</UDNavLink>*/}
      {/*<UDNavLink*/}
      {/*  to={Pages.SUPPORT}*/}
      {/*  className="d-flex align-items-center pl-10 pr-6 py-2">*/}
      {/*  <UDColorableIcon*/}
      {/*    name="support"*/}
      {/*    componentProps={{ className: 'mr-2' }}*/}
      {/*  />*/}
      {/*  Помощь*/}
      {/*</UDNavLink>*/}
    </S.MenuSystemNavigation>
  );
};

export default UDMenuSystemNavigation;
